import { render, staticRenderFns } from "./DoctorExpenses.vue?vue&type=template&id=13265b20&scoped=true"
import script from "./DoctorExpenses.vue?vue&type=script&lang=js"
export * from "./DoctorExpenses.vue?vue&type=script&lang=js"
import style0 from "./DoctorExpenses.vue?vue&type=style&index=0&id=13265b20&prod&scoped=true&lang=css"
import style1 from "./DoctorExpenses.vue?vue&type=style&index=1&id=13265b20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13265b20",
  null
  
)

export default component.exports